// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BonusSystem_wrapper__2lgjc","container":"BonusSystem_container__23hdO","dot":"BonusSystem_dot__7wI4r","instRef":"BonusSystem_instRef__3NAFS"};